import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getParty,
  getIdParty,
  createParty,
  updateParty,
  deleteParty,
  createPartyDuplicate,
  getPartyMaster,
  // deleteById,
} from "./partyAPI";

const initialState = {
  data: [],
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
  permissionParty: [],
};

export const fetchParty = createAsyncThunk(
  "Party/fetchParty",
  async (payload) => {
    const response = await getParty(payload);
    return response;
  }
);
export const fetchPartyMaster = createAsyncThunk(
  "Party/fetchPartyMaster",
  async (payload) => {
    const response = await getPartyMaster(payload);
    return response;
  }
);


export const addParty = createAsyncThunk("Party/addParty", async (payload) => {
  const response = await createParty(payload);
  return response;
});

export const editParty = createAsyncThunk(
  "Party/editParty",
  async (payload) => {
    const response = await updateParty(payload);
    return response;
  }
);

export const fetchIdParty = createAsyncThunk(
  "Party/fetchIdParty",
  async (id) => {
    const response = await getIdParty(id);
    return response;
  }
);

export const removeParty = createAsyncThunk(
  "Party/removeById",
  async (payload) => {
    const response = await deleteParty(payload);
    return response;
  }
);

export const addDuplicateParty = createAsyncThunk(
  "Party/addDuplicateParty",
  async (payload) => {
    const response = await createPartyDuplicate(payload);
    return response;
  }
);

export const partySlice = createSlice({
  name: "party",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    setPermissionParty: (state, action) => {
      state.permissionParty = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchParty.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchParty.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchPartyMaster.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPartyMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchIdParty.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdParty.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })

      .addCase(addParty.pending, (state) => {
        state.loading = true;
      })
      .addCase(addParty.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(editParty.pending, (state) => {
        state.loading = true;
      })
      .addCase(editParty.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(removeParty.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeParty.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(addDuplicateParty.pending, (state) => {
        state.loading = true;
      })
      .addCase(addDuplicateParty.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const {
  resetData,
  setSelected,
  setPermissionParty,
} = partySlice.actions;

export const selectParty = (state) => state.party.data;
export const selectIdParty = (state) => state.party.dataId;
export const selectLoading = (state) => state.party.loading;
export const selectError = (state) => state.party.error;
export const selectPageNo = (state) => state.party.pageNo;
export const selectPageSize = (state) => state.party.pageSize;
export const selectTotalRecord = (state) => state.party.totalRecord;
export const selectSelected = (state) => state.party.selected;
export const selectResult = (state) => state.party.result;
export const selectPermissionParty = (state) => state.party.permissionParty;

export default partySlice.reducer;
